import { plural } from "@lingui/core/macro";
import ExternalChannelLink from "./ExternalChannelLink";
import { ChannelV4, EpisodeV4, MentionCard } from "@/types/MentionCard";

type HeaderProps = {
  channelType: ChannelV4["channel_type"];
  websiteUrl: ChannelV4["website_url"];
  externalId: ChannelV4["external_id"];
  shareUrl: MentionCard["share_url"];
  audioUrl: EpisodeV4["audio_url"];
  channelName: ChannelV4["name"];
  totalMentionsCount: number;
};

export default function Header({
  totalMentionsCount,
  channelName,
  channelType,
  externalId,
  websiteUrl,
  audioUrl,
  shareUrl,
}: HeaderProps) {
  return (
    <div className="flex items-center justify-between gap-2 text-muted-foreground text-sm">
      <ExternalChannelLink
        channelType={channelType}
        channelName={channelName}
        websiteUrl={websiteUrl}
        externalId={externalId}
        audioUrl={audioUrl}
        shareUrl={shareUrl}
      />

      <p>
        {totalMentionsCount}{" "}
        {plural(totalMentionsCount, {
          one: "omnämnande",
          other: "omnämnanden",
        })}
      </p>
    </div>
  );
}
